import React, { forwardRef } from 'react';

/**
 * Textarea wrapping `.input-field`.
 */
const Textarea = forwardRef(function Textarea({ className = '', ...rest }, ref) {
  return <textarea ref={ref} className={`input-field ${className}`.trim()} {...rest} />;
});

export default Textarea;
